import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { AppHeader } from '@components/AppHeader/AppHeader';
import NoResults from '@components/NoResults/NoResults';
import { TripCard } from '@components/TripCard/TripCard';
import { ERoutes } from '@enums/routes.enum';
import useApi from '@hooks/useApi';
import useTripSocket from '@hooks/useTripSocket';
import type { RootState } from '@store/store';
import type { Trip } from '@store/trips/tripsSlice';

import classes from './Trips.module.scss';

const Trips = () => {
	const trips = useSelector((state: RootState) => state.trips.data);

	const { getSingleTrip, getSingleReservation } = useApi();
	const { handleTripsSocketEvents } = useTripSocket();
	const navigate = useNavigate();

	const handleOnClick = (tripId: Trip['id']) => {
		getSingleTrip(tripId);
		getSingleReservation(trips.find((trip) => trip.id === tripId)?.reservations?.[0]?.id || 0);
		navigate(ERoutes.tripInfo);
	};

	useEffect(() => {
		if (trips?.length) {
			const socketTripsIds = trips.map((trip) => trip.id);
			handleTripsSocketEvents(socketTripsIds);
		}
	}, [trips?.length]);

	return !trips?.length ? (
		<NoResults />
	) : (
		<div className={classes['container']}>
			<AppHeader showBorder />
			<div className={classes['tripsContainer']}>
				{trips.map((trip) => (
					<TripCard
						key={trip.id}
						from={trip.from}
						to={trip.to}
						date={trip.date}
						status={trip.status}
						onClick={() => handleOnClick(trip.id)}
					/>
				))}
			</div>
		</div>
	);
};

export default Trips;
